var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('PageBuilder',{key:'builder' + _vm.$root.$children[0].viewComponentKey,attrs:{"currentPageId":_vm.$root.$children[0].currentPageId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }